<template>
<div class="bg-white px-3 py-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
<div class="d-flex align-items-center">
  <el-form inline ref="form" :model="searchform">
     <el-form-item class="mb-0 mr-0">
      <el-button type="danger" size="mini" @click="deleteAll">{{$t('searchText.선택삭제')}}</el-button>
    </el-form-item>

     <el-form-item  class="mb-0">
             <el-date-picker
                  v-model="searchform.time"
                  type="daterange"
                  range-separator="~"
                 :start-placeholder="$t('searchText.시작')"
                  :end-placeholder="$t('searchText.마감')" size="mini" class="mr-2" value-format="yyyy-MM-dd">
                </el-date-picker>
          </el-form-item>

      <el-form-item class="mb-0 mr-0">
             <el-select v-model="searchform.value" :placeholder="$t('status.선택')" size="mini" style="width:120px;">
               <el-option
                      v-for="item in searchform.searchOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
          </el-form-item>
          <el-form-item class="mb-0 mr-0">
             <el-input :placeholder="$t('searchText.키워드')" v-model="searchform.keyword" size="mini" style="width:150px" ></el-input>
          </el-form-item>
           <el-form-item class="mb-0 mr-0">

            <el-button type="info" size="mini" @click="sEvent">{{$t('searchText.검색')}}</el-button>  
            <el-button type="success" size="mini" @click="openModel(false)">{{$t('tableText.추가')}}</el-button>
           
          </el-form-item>
  </el-form>
</div>
 
  <el-table
      :data="tableData"
       v-loading="loading"
       style="width: 100%"
       border class="mt-2"
       :empty-text="$t('tableText.데이타가없습니다')" @selection-change="handleSelectionChange">
         <el-table-column
      type="selection"
      width="55"
      align="center">
    </el-table-column> 
       <el-table-column 
         label="ID" prop="id" align="center" width="150">
         </el-table-column>
   

     
      <el-table-column
        :label="$t('nav.아이디')" prop="mem_id" align="center">
          <template slot-scope="scope">
            
             <span @click="openIdModel(scope.row.mem_id,'tab1')" class="text-primary" style="cursor:pointer">{{scope.row.mem_id}}</span>
          </template>
      </el-table-column> 
       <el-table-column
        :label="$t('tableText.알본사')" v-if="this.userid=='admin'" prop="admin_id" align="center">       
      </el-table-column>

       <el-table-column
        :label="$t('newAdd.쿠폰금액')" prop="money" align="center">
        <template slot-scope="scope">
              {{formatMoney(scope.row.money)}}
          </template>
      </el-table-column>

       <el-table-column
        :label="$t('tableText.추가시간')" prop="add_time" align="center">
       
      </el-table-column>
        <el-table-column
        :label="$t('newAdd.만기일')" prop="end_time" align="center">
       
      </el-table-column>

        <el-table-column
        :label="$t('newAdd.사용조건')" prop="condition" align="center">
        <template slot-scope="scope">
              {{formatMoney(scope.row.condition)}}
          </template>
      </el-table-column>

      
       <el-table-column
        :label="$t('newAdd.사용시간')" prop="run_time" align="center">
       
      </el-table-column>

         <el-table-column
        :label="$t('newAdd.쿠폰유형')" prop="sty" align="center">
        <template slot-scope="scope">
              {{  cpTypeObj[scope.row.sty]}}
          </template>
      </el-table-column>


      <el-table-column
        :label="$t('newAdd.비고')" prop="doc" align="center" width="300">
       <template slot-scope="scope">
            <el-input
            type="textarea"
            :rows="1"
            v-model="scope.row.doc">
          </el-input>
          </template>
      </el-table-column>
       <el-table-column
        :label="$t('tableText.상태')" prop="status" align="center">
        <template slot-scope="scope">
             <span :class="statusClass[scope.row.status]">{{statusObj[scope.row.status]}}</span>
          </template>
      </el-table-column>
        <el-table-column
        :label="$t('newAdd.머니구분')" prop="money_type" align="center">
        <template slot-scope="scope">
             <span class="text-primary"><span :class="typeClass[scope.row.money_type]">{{moneyTypeObj[scope.row.money_type]}}</span></span>
          </template>
      </el-table-column>
      <el-table-column
        :label="$t('tableText.수정')" align="center">
         <template slot-scope="scope">
           <el-button-group>
             <el-button type="primary" icon="el-icon-edit"  @click="openModel(scope)" size="mini"></el-button>
              
            </el-button-group>
          </template>
      </el-table-column>
      </el-table>
     <div style="height: 100px;"></div>
                      <el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
				  <div style="flex: 1;" class="px-2">
					  <el-pagination
					  :current-page="currentPage"
					  :page-sizes="[5, 10, 15, 20]"
					  :page-size="size"
					  layout="prev, pager, next"
					  :total="total"
					  @size-change="handleSizeChange"
      				  @current-change="handleCurrentChange">
					</el-pagination>
				  </div>
				</el-footer>	
         <el-dialog
          :title="title"
          :visible.sync="creatModel" :width="layoutWidth" :close-on-click-modal ="false">

          <el-form ref="form" :model="form" label-width="100px" v-loading="loading" :rules="rules">
           
            
                    <el-form-item :label="$t('nav.아이디')" prop="mem_id" class="mb-0">
                      <div class="d-flex"> 
                         <el-autocomplete v-model="form.mem_id" :fetch-suggestions="querySearchAsync" :trigger-on-focus="false" @select="handleSelect" class="w-75"></el-autocomplete>
                           
                            <el-select v-if="form.habu!=''" v-model="form.habu"  :placeholder="$t('status.선택')"  style="width:120px;margin-left: 5px;">
                             <el-option
                                v-for="item in couponOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                              </el-option>
                        </el-select>
                      </div>
                     
                        
                    </el-form-item>
                 
                    <el-form-item :label="$t('newAdd.쿠폰금액')" prop="money" class="mb-0">
                        <el-input v-model="form.money"></el-input>
                    </el-form-item>
                  <el-form-item :label="$t('newAdd.사용조건')" prop="condition" class="mb-0">
                        <el-input v-model="form.condition" style="width:100px;margin-right:10px" placeholder="입금금액"></el-input>{{$t('newAdd.입금')}}
                    </el-form-item>
                     <el-form-item :label="$t('newAdd.만기일')" prop="end_time" class="mb-0">
                       <el-date-picker
                          v-model="form.end_time"
                          type="date" value-format="yyyy-MM-dd"
                         >
                        </el-date-picker>
                      </el-form-item>
                   <el-form-item :label="$t('newAdd.머니구분')" class="mb-0" prop="money_type">
                     <el-radio-group v-model="form.money_type" size="small">
                       
                        <el-radio :label="2" border>{{$t('msg.카슬머니')}}</el-radio>
                         <el-radio :label="1" v-if="this.power=='1'" border>{{$t('msg.파워머니')}}</el-radio>
                         <el-radio :label="3" border>{{$t('newAdd.알머니')}}</el-radio>
                     </el-radio-group>
                      <el-tooltip  placement="bottom">
                         <div slot="content">{{$t('newAdd.일반회원은가슬머니또는파워머니가능')}}<br/>{{$t('newAdd.파트너는알머니만가능합니다')}}</div>
                            <el-button type="danger" icon="el-icon-question" style="background: transparent;color: #000;margin-left:5px;font-size: 18px !important;border:none;padding:0"></el-button>
                      </el-tooltip>

                    </el-form-item>
                     <el-form-item :label="$t('newAdd.쿠폰유형')"  class="mb-0">
                      
                         
                            <el-select  v-model="form.sty"  :placeholder="$t('status.선택')"  style="width:120px;">
                             <el-option
                                v-for="item in styOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                              </el-option>
                        </el-select>
                     
                     
                        
                    </el-form-item>
                     <el-form-item :label="$t('newAdd.비고')" prop="doc" class="mb-0">
                        <el-input
                            type="textarea"
                            :rows="4"
                            v-model="form.doc">
                          </el-input>
                      </el-form-item>
                

          </el-form>
          <span slot="footer" class="dialog-footer">
             <el-button @click="creatModel = false">{{$t('msg.취소')}}</el-button>
            <el-button type="primary" @click="submit" :loading="couponLoad">{{$t('msg.확인')}}</el-button>
          </span>
        
       
       
        </el-dialog>
        
          
       <div class="dialogLayer" v-show="shareShow" @click="shareShow=!shareShow">
      </div>     
       
         
				
</div>
 </template>

 <script>
 import layer from '../../components/common/layer.vue';
import layerNew from '../../components/common/layer-new.vue';

    export default {
     
     components: {
  
      layer,
      layerNew,
    
    },

    	data(){
    		return{
          restaurants: [],
          shareShow:false,
          state: '',
          timeout:  null,
          title:this.$i18n.t("tableText.추가"),
         
          couponLoad:false,
          layoutWidth:'500px',
          typeClass:{
            '1':'text-success',
            '2':'text-primary'
          },
          statusClass:{
             '0':'text-danger',
             '1':'text-primary',
             '-4':'',
             '2':'text-primary',
             
          },
          searchform:{
            time:[],
            keyword:'',
            searchOptions:[
             
             {
              label:this.$i18n.t("nav.아이디"),
              value:'mem_id'
            },
               
           

            {
              label:this.$i18n.t("msg.알본"),
              value:'admin_id'
            } 
            ],
           
            value:'',
          },
             pickerOptions: {
          },
            shortcuts: [{
            text:this.$i18n.t("dateText.최근한주"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근한달"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근3개월"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }],
          
         
          domain:window.sessionStorage.getItem('domain'),
          sitetype:window.sessionStorage.getItem('sitetype'),
          bg:window.sessionStorage.getItem('bg'),
          power:window.sessionStorage.getItem('power'),
          rosing:window.sessionStorage.getItem('rosing'),
          userid:window.sessionStorage.getItem('userid'),
          aid:window.sessionStorage.getItem('admin_id'),
          formLoading:false,
          idDialogVisible: false,
          data:[],

        
          tableLoading:false,
          dialogVisible: false,
          dialogTitle: this.$i18n.t("title.소속총판"), // 标题
          editIndex:-1,
          creatModel:false,
          statusOptions:[
             {
              label:this.$i18n.t("msg.정상"),
              value:'1'
            },
             {
              label:this.$i18n.t("msg.차단"),
              value:'0'
            },
            {
              label:this.$i18n.t("status.선택"),
              value:''
            },

            ],
            couponOptions:[  
           {
              label:this.$i18n.t("newAdd.본인"),
              value:'0'
            },
            {
              label:this.$i18n.t("newAdd.하부회원"),
              value:'1'
            },
            ],
          styOptions:[  
           {
              label:this.$i18n.t("newAdd.가입쿠폰"),
              value:'1'
            },
            {
              label:this.$i18n.t("newAdd.이벤트쿠폰"),
              value:'2'
            },
            {
              label:this.$i18n.t("newAdd.감사쿠폰"),
              value:'3'
            },
            {
              label:this.$i18n.t("newAdd.등급업쿠폰"),
              value:'4'
            },
            {
              label:this.$i18n.t("newAdd.기타"),
              value:'5'
            },
            ],
    		  form:{
           money_type:'',
           id:'',
           mem_id:'',
           moeny:'',
           end_time:'',
           doc:'',
          condition:'',
         
            habu:'0',
            sty:'1',
          },
          optvalue:[
           {
              label:'1',
              value:'1'
            },
             {
              label:'2',
              value:'2'
            },
             {
              label:'3',
              value:'3'
            },


          ],
          moneyTypeObj:{
             '1':this.$i18n.t("msg.파워머니"),
             '2':this.$i18n.t("msg.카슬머니"),
             '3':this.$i18n.t("newAdd.알머니"),
          },
          cpTypeObj:{
             '1':this.$i18n.t("newAdd.가입쿠폰"),
             '2':this.$i18n.t("newAdd.이벤트쿠폰"),
             '3':this.$i18n.t("newAdd.감사쿠폰"),
             '4':this.$i18n.t("newAdd.등급업쿠폰"),
             '5':this.$i18n.t("newAdd.기타"),
          },
          statusObj:{
            '0':this.$i18n.t("newAdd.미사용"),
            '1':this.$i18n.t("newAdd.사용완료"),
            '2':this.$i18n.t("newAdd.만기"),
            '-4':this.$i18n.t("msg.취소"),
          },
          valuenum:'1',
    	
		    		 total:0,
		    		 size:0,
		    		 loading: false,
		    		 tableData: [],
			       currentPage:1,
             multipleSelection:[],
			       rules: {
                
                  mem_id:[{ required: true, message: '', trigger: 'blur'}],
                  money:[{ required: true, message: '', trigger: 'blur'}],
                  end_time:[{ required: true, message: '', trigger: 'blur'}],
                  doc:[{ required: true, message: '', trigger: 'blur'}],
                  money_type:[{ required: true, message: '', trigger: 'blur'}],
                  condition:[{ required: true, message: '', trigger: 'blur'}],
                },
              
			         
			 
    			}
    			
    			
    		},
    		created() {
    			

    			this.getList();
    			
			
		},
   
    	methods:{
        querySearchAsync(queryString, cb) {
       let token=window.sessionStorage.getItem('user');
           
              this.$axios({
                    method:'put',
                    url:this.domain+'/admin/id_like?mem_id='+this.form.mem_id,
                   
                    'Accept': 'application/json',
                     headers: { 'Authorization': 'Bearer ' + token },
      
              }).then((response) =>{ 

               let item = response.data.data.data;

               this.restaurants = item;
                   // return this.restaurants;

                  var restaurants = this.restaurants;
                 //console.log('restaurants==',restaurants)
                          // 解决element建议搜索框无法显示内容 的数据处理
                          for (var i = 0; i < restaurants.length; i++) {
                            restaurants[i].value = restaurants[i].mem_id;
                          }
                          var results = queryString
                            ? restaurants.filter(this.createStateFilter(queryString))
                            : restaurants;
                          // 调用 callback 返回建议列表的数据
                          clearTimeout(this.timeout);
                          this.timeout = setTimeout(() => {
                            cb(results);
                          }, 500 * Math.random());
                                      
   
                 
              }).catch((error) =>{
                 this.$message({
                          message:'error',
                          type:'error'
                      })   

                   
              })
 
    },
    createStateFilter(queryString) {
      return (state) => {
        return (
          state.mem_id.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },

      handleSelect(item) {
        console.log('item',item.mem_id);
        this.form.mem_id = item.mem_id;
      },
          handleSelectionChange(val) {
          //console.log(val)
                this.multipleSelection = val;

      },
         // 删除
      deleteAll(){
        this.$confirm(this.$i18n.t("msg.삭제하시겠습니까"), this.$i18n.t("msg.알림"), {
          confirmButtonText: this.$i18n.t("msg.삭제"),
          cancelButtonText: this.$i18n.t("msg.취소"),
          type: 'warning'
        }).then(() => {
          let token=window.sessionStorage.getItem('user');
   
              let newids=[];

           this.multipleSelection.forEach(item=>{
            
            //console.log('id',item.idx);
            newids.push(item.id);
           });

          this.$axios({
                      method:'post',
                       data:{idx:newids},
                      url:this.domain+'/admin/coupon_del',
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                    
                    if(response.data.code==200){
                      this.$message({
                      message:response.data.msg,
                      type:'success'
                    })
                    }else{
                      this.$message({
                      message:response.data.msg,
                      type:'error'
                    })
                    }

                     this.loading = false
                    
                    this.getList()
    
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
                  
       

          }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$i18n.t("msg.취소됨")
          });          
        });

        
      },  
         
        sEvent(){

                if(this.searchform.keyword!='' && this.searchform.value == ''){
                  this.$message(this.$i18n.t("msg.검색타이틀선택하세요"));
                   return;
                }

          this.getList();
          
             

        },
          cancelEvent(){
          this.shareShow = false
        },
      
         openIdModel(id,e){

          if(this.aid=='soft10')
           {
            this.shareShow = true

                this.$layer.iframe({
                type: 2,
                title: id,
                content: {
                    content: layerNew,
                    parent: this,
                    data:{
                    info:{id:id},
                    activeTab:e,
                    layerid:'id'
                    }
                  
                },
              
                shadeClose: true,
                maxmin:true,
                shade: false,
                area: ['1200px', '740px'],
                cancel:()=>{
                  this.shareShow = false
                  console.log(close)
                }
                
             
             });

              return;
           }
           
           this.$layer.iframe({
            type: 2,
            title: '',
            content: {
                content: layer,
                parent: this,
                data:{
                info:{id:id},
                layerid:'id'
                }
              
            },
            shadeClose: false,
             maxmin : true,

            shade: false,
            area: ['830px', '680px'],
           
        });
        
        },
       
        
   

        openModel(e = false){
          let token=window.sessionStorage.getItem('user');
          if(!e){
            this.form = {
                  
                  mem_id:'',
                  money:'',
                  end_time:'',
                  doc:'',
                  money_type:2,
                  habu:'0',
                  sty:'1',
                  condition:'',

                 }
             this.editIndex = -1

          }
          else{
            //修改
            this.title=this.$i18n.t("tableText.수정")
            this.loading = true
            this.$axios({
                  method:'get',
                  url:this.domain+'/admin/coupon?id='+e.row.id,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
    
            }).then((response) =>{ 
              
                  this.loading = false
                  let item = response.data.data 
                    this.form = {

                          id:item.id,
                          mem_id:item.mem_id,  
                          money:item.money,
                          end_time:item.end_time,
                          doc:item.doc,
                          money_type:item.money_type,
                          condition:item.condition,
                          habu:'',
                          sty:item.sty
                        
                         
                         

                }
                this.editIndex = e.$index
               
            }).catch((error) =>{
                console.log(error)       //请求失败返回的数据
            })
          }
          this.creatModel = true
        },
         
    		 submit(){
             
              let token=window.sessionStorage.getItem('user');
              this.$refs.form.validate((e)=>{
             if(!e) return;

              this.couponLoad =true
          
             //添加提交
              if (this.editIndex === -1) {
                 this.loading =true
               this.$axios({
                        method:'post',
                        url:this.domain+'/admin/coupon_insert',
                        data:{
                        
                          id:this.form.id,
                          mem_id:this.form.mem_id,
                          money:this.form.money,
                          end_time:this.form.end_time,
                          doc:this.form.doc,
                          money_type:this.form.money_type,
                          condition:this.form.condition,
                          habu:this.form.habu,
                          sty:this.form.sty

                          
                        },
                        'Accept': 'application/json',
                         headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                         this.couponLoad = false
                         if(response.data.code !=200)
                            {
                               this.$message({
                            message:response.data.msg,
                            type: 'warning'
                          });


                                
                            }else{
                               this.$message.success(this.$i18n.t("msg.완료"));
                               //console.log(this.form);
                               this.getList();
                               //this.tableData.unshift(this.form)
                               //关闭
                               this.creatModel = false

                            }
                           this.loading =false
                     
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                       this.loading =false
                  })
              
            }else{
              
              this.$axios({
                      method:'post',
                      url:this.domain+'/admin/coupon_up',
                      data:{
                         
                          id:this.form.id,
                          mem_id:this.form.mem_id,
                          money:this.form.money,
                          end_time:this.form.end_time,
                          doc:this.form.doc,
                          money_type:this.form.money_type,
                          condition:this.form.condition,
                          sty:this.form.sty
                         
                         
                        },   
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                    this.couponLoad = false
                   if(response.data.code==200){
                       this.creatModel = false
                       this.$message({
                          message:response.data.msg,
                          type:'success'
                      })  
                      this.getList() 
                    }else
                    {
                        // this.creatModel = false
                       this.$message({
                          message:response.data.msg,
                          type:'error'
                      })   
                    }
                    
                   
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })

            }
            })
              
            
        },
		
    		 handleSizeChange(val) {
			        //console.log(`每页 ${val} 条`);
			        this.size = val
			        this.getList();
			        this.loading= true

			      },
			      handleCurrentChange(val) {
			        //console.log(`当前页: ${val}`);
			        this.currentPage = val
			        this.getList();
			        this.loading= true
			      },
			    
       
    		getList(){

    		
              
    			this.loading = true

           let s_time="";
               let e_time="";

               if(this.searchform.time.length>0)
               {
                  s_time=this.searchform.time[0];
                  e_time=this.searchform.time[1];
               }   

    			 let token=window.sessionStorage.getItem('user');
    				//console.log(token);
    			 let urls=this.domain+'/admin/couponlist?s_time='+s_time+'&e_time='+e_time+'&page='+this.currentPage+'&'+this.searchform.value+'='+this.searchform.keyword;

    			this.$axios({
	                method:'get',
	                url:urls,
	                'Accept': 'application/json',
	                 headers: { 'Authorization': 'Bearer ' + token },
                
               
            }).then((response) =>{ 


                     console.log('tableData=',response.data.data)
                     let data = response.data.data
                     this.tableData =data.data
                     this.total = data.total
                     this.currentPage = data.current_page
                     this.size =data.per_page
                     
                     this.loading =false
               
            }).catch((error) =>{
            	
               this.$message.error(error);
              this.loading = false
                //console.log('error',error.response)       //请求失败返回的数据
               
            })
    		},
        
    
   
    		
        
        
    	}
  }
</script>

 <style scoped>

/deep/ .el-dialog__footer {
  padding:0px 20px 20px;
}

 /deep/ .el-dialog__body{
  padding:10px 20px;

 }
 >>>.formItem2 label.el-form-item__label{
    color: #444 !important;
    text-align: left;
    padding-left: 5px;
    line-height: 36px;

 }
>>>.el-radio{
  margin-right: 0;
}
</style>


// WEBPACK FOOTER //
// src/views/coupon/list.vue